import { IGetAllEspecificidadeObraUseCase } from "../../../presentation/useCases/read/get_all_especificidade_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { EspecificidadeObra } from "../../models/especificidade_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllEspecificidadeObraUseCase
 */

export class GetAllEspecificidadeObraUseCase
  extends BasePaginatedUseCase<EspecificidadeObra>
  implements IGetAllEspecificidadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllEspecificidadeObra(
    idObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('IdObra invalido!');

    const response = await this.repository.getAllEspecificidadeObra(
      idObra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
